import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { WelcomeClarity } from "@/screens/welcome/WelcomeClarity";
import { API_ORIGIN } from "@/admin/ui";
import { Dawn } from "@/components/hm/Basics";
import { LandingNav } from "@/screens/landing/Top";
import { SiteFooter } from "@/components/hm/SiteFooter";
import { AudioPlayer } from "@/components/hm/AudioPlayer";
import { UNDERSTAND } from "@/screens/welcome/understand";
import { WelcomeModule } from "@/screens/landing/WelcomeModule";

export function WelcomeModulePage() {
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, []);
  return (
    <div className="welcome-mod force-dark" style={{ marginBottom: 0 }} data-testid="welcome-module-page">
      <LandingNav />
      <main style={{ position: "relative", paddingTop: 90 }}>
        <Dawn style={{ opacity: 0.22 }} />
        <WelcomeModule />
      </main>
      <SiteFooter />
    </div>
  );
}

export function UnderstandPage() {
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, []);
  return (
    <div className="welcome-mod force-dark" style={{ marginBottom: 0 }} data-testid="welcome-understand-page">
      <LandingNav />
      <main style={{ position: "relative", paddingTop: 150, paddingBottom: 110 }}>
        <Dawn style={{ opacity: 0.22 }} />
        <article className="wrap und-page" data-testid="welcome-understand-text">
          <h1 className="hm-h1" data-testid="welcome-understand-title">Entender lo que te está pasando</h1>
          <p className="und-sub" data-testid="welcome-understand-subtitle">Lo que sientes tiene sentido</p>
          {UNDERSTAND.map((s, i) => (
            <section key={i} className="und-sec">
              {s.h && <h2>{s.h}</h2>}
              {s.p.map((p) => <p key={p.slice(0, 30)}>{p}</p>)}
              {s.close && <p className="wm-close">{s.close}</p>}
            </section>
          ))}
          <WelcomeClarity />
          <Link to="/modulo-bienvenida" className="btn btn-primary wm-btn" style={{ marginTop: "3rem" }} data-testid="welcome-understand-back">Volver al módulo de bienvenida</Link>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}

export function PracticePage() {
  const [res, setRes] = useState(null);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    api.get("/resources/practica-introspeccion").then((r) => setRes(r.data)).catch(() => setRes({ visible: true, slots: {} }));
  }, []);
  if (res && !res.visible) return <Navigate to="/modulo-bienvenida" replace />;
  const audio = res?.slots?.audio?.[0];
  return (
    <div className="welcome-mod force-dark" style={{ marginBottom: 0 }} data-testid="welcome-practice-page">
      <LandingNav />
      <main style={{ position: "relative", paddingTop: 150, paddingBottom: 110 }}>
        <Dawn style={{ opacity: 0.25 }} />
        <article className="wrap und-page">
          <h1 className="hm-h1" data-testid="welcome-practice-title">Práctica guiada de introspección</h1>
          <p className="und-sub" data-testid="welcome-practice-subtitle">Escucha lo que se mueve dentro de ti</p>
          <section className="und-sec">
            <p data-testid="welcome-practice-intro">Esta práctica es un espacio para parar, respirar y escuchar lo que se mueve dentro de ti sin prisa. No tienes que hacer nada bien. Solo estar. Déjate acompañar.</p>
          </section>
          <AudioPlayer src={audio ? `${API_ORIGIN}${audio.url}` : ""} title="Práctica guiada de introspección" />
          <Link to="/modulo-bienvenida" className="btn btn-primary wm-btn" style={{ marginTop: "3rem" }} data-testid="welcome-practice-back">Volver al módulo de bienvenida</Link>
        </article>
      </main>
      <SiteFooter />
    </div>
  );
}
